function Header({ title }) {
  return (
    <header className="portfolio-header">
      <h1>Developer Portfolio</h1>
      <div className="header-decleration"></div>
    </header>
  );
}

export default Header;
